

import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import BlogTagTable from "./Components/BlogTagTable";

const BlogTagList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Blog Tags</HeadingOne>
                    <div className="d-flex gap-2 flex-wrap mt-sm-0 mt-2">
                        <AddItemBtn url="add-blog-tag" title="Add Tag" />
                    </div>
                </>
            }
        >
            <div className="col-12">
                <BlogTagTable />
            </div>
        </PageBody>
    );
};

export default BlogTagList;
